<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Chuyên cần bán trú"
          :link="[{ text: 'Chuyên cần bán trú', href: '../boarding-class' }]"
        />
      </div>
    </div>
    <v-tabs class="mx-md-4" v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab v-for="item in getTabs" :key="item" class="tab-default">
        {{ item }}
      </v-tab>
    </v-tabs>

    <v-card outlined class="mx-md-4 elevation-0">
      <v-tabs-items v-model="tab" v-if="getTabs.length > 0">
        <v-tab-item v-if="getTabs.includes('Điểm danh')" :key="0">
          <BoardingClassAttendances />
        </v-tab-item>
        <!-- <v-tab-item v-if="getTabs.includes('Chuyên cần')" :key="1">
          <BoardingClassClassReport />
        </v-tab-item>
        <v-tab-item v-if="getTabs.includes('Thống kê')" :key="2">
          <BoardingClassChart />
        </v-tab-item> -->
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import BoardingClassAttendances from '../report/BoardingClassAttendances.vue'
import BoardingClassClassReport from '../report/BoardingClassClassReport.vue'
import BoardingClassChart from '../report/BoardingClassChart.vue'

export default {
  components: {
    Breadcrumbs,
    BoardingClassAttendances,
    BoardingClassClassReport,
    BoardingClassChart,
  },
  data() {
    return {
      tab: 0,
    }
  },
  computed: {
    getTabs() {
      const tabs = []
      if (this.$auth.policies['view-diligence-list']) {
        tabs.push('Điểm danh')
      }
      // if (this.$auth.policies['view-diligence-list']) {
      //   tabs.push('Chuyên cần')
      // }
      // if (this.$auth.policies['view-diligence-list']) {
      //   tabs.push('Thống kê')
      // }
      return tabs
    },
  },
}
</script>
